/**
 * Created by saeed on 12/29/2016.
 */
import {Injectable} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/Rx';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {
  API_URL_PRICE_INFO_DETAIL_BY_SERVICE_ID_SERVANTID_ANDSTARTDATE,
  API_URL_CANCEL_RESERVE,
  API_URL_APPVISER_SAVE_CLIENT_RESERVE,
  API_URL_AUTO_SELECT_SERVANT_BY_SERVICE_ID,
  API_URL_SAVE_CLIENT_RESERVE,
  API_URL_GET_AVAILABLE_CAPACITY_FOR_TIMESPAN,
  API_URL_PRICE_INFO_DETAIL_BY_SERVICE_ID_ANDSTARTDATE,
  API_URL_PAY_ORDER_BAG,
  API_URL_GET_USER_CAN_PAY_INPLACE,
  API_URL_PRICE_INFO_DETAIL_BY_SERVICE_ID,
  API_URL_CONFIRM_ORDER_BAG_PAYMENT,
  API_URL_GET_ORDER_BAG_BY_AUTHORITY,
  API_URL_SERVICE_OPTIONS_BY_SERVICE_ID,
  API_URL_CONFIRM_ORDER_BAG,
  API_URL_SERVICE_TIME_SESSION_BY_ID,
  API_URL_GET_ORDER_BAG_DETAIL_BY_ID,
  API_URL_GET_ORDER_BAG_LIST,
  API_URL_GET_ORDER_BAG_BY_ID,
  API_URL_PRICE_INFO_DETAIL_BY_SERVICE_ID_ANDTIMESESSION,
  API_URL_COMPUTE_ORDER_BAG_PRICE,
  API_URL_FINAL_CONFIRM_ORDER_BAG,
  API_URL_DELETE_ORDER_BAG_BY_AUTHURITY,
  API_URL_GET_VIDEO_MEETING_LINK_BY_ORDER_BAG_ITEM_ID,
  API_URL_EVALUATE_COUPON,
  API_URL_LOG_INTO_SERVER, API_URL_SAVE_REMOVE_ORDER_BAG_SERVICE_ITEM_BY_ID

} from '../constants';
import {CategoryVM} from "../../models/CategoryVM.model";
import {ServiceItemVM} from "../../models/ServiceItemVM";
import {ServiceItemDetailVM} from "../../models/ServiceItemDetailVM";
import {SessionDateVM} from "../../models/SessionDateVM.model";
import {SessionTimeVM} from "../../models/SessionTimeVM.model";
import {PriceInfoDetailVM} from "../../models/PriceInfoDetailVM.model";
import {ServiceOptionVM} from "../../models/ServiceOptionVM.model";
import {OrderBagVM} from "../../models/OrderBagVM.model";
import {BaseHttpService} from "../base-http-service";
import {ServantVM} from "../../models/ServiceItemDetailVM";
import {CouponVM} from "../../models/CouponVM.model";
import {CouponResultVM} from "../../models/CouponResultVM.model";

@Injectable()
export class OrderBagService {
  // Resolve HTTP using the constructor
  constructor(private http: BaseHttpService) {


  }

  getPriceInfoDetailByServiceId(serviceid: number): Observable<PriceInfoDetailVM[]> {
    return this.http.get(API_URL_PRICE_INFO_DETAIL_BY_SERVICE_ID + '?serviceItemId=' + serviceid)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  getPriceInfoDetailByServiceIdAndTimeSession(serviceid: number, timesessionid: number): Observable<PriceInfoDetailVM[]> {
    return this.http.get(API_URL_PRICE_INFO_DETAIL_BY_SERVICE_ID_ANDTIMESESSION + '?serviceItemId=' + serviceid + '&serviceTimeSessionId=' + timesessionid)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {

        return res;
      })
      //...errors if any
      .catch((error: any) =>
        Observable.throw(error || 'Server error')
      );
  }

  getPriceInfoDetailByServiceIdAndStartDate(serviceid: number, startDate: Date): Observable<PriceInfoDetailVM[]> {
    return this.http.get(API_URL_PRICE_INFO_DETAIL_BY_SERVICE_ID_ANDSTARTDATE + '?serviceItemId=' + serviceid + '&reserveDate=' + startDate)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  getPriceInfoDetailByServiceIdAndServantIdAndStartDate(serviceid: number, servantId: number, startDate: Date): Observable<PriceInfoDetailVM[]> {

    var url = API_URL_PRICE_INFO_DETAIL_BY_SERVICE_ID_SERVANTID_ANDSTARTDATE + '?serviceItemId=' + serviceid + '&reserveDate=' + startDate;
    if (servantId)
      url = url + '&servantId=' + servantId;
    return this.http.get(url)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  getServiceItemOptionsByServiceItemid(serviceid: number): Observable<ServiceOptionVM[]> {
    return this.http.get(API_URL_SERVICE_OPTIONS_BY_SERVICE_ID + '?serviceItemId=' + serviceid)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  getServiceTimeSessionById(sessionid: number): Observable<SessionTimeVM> {
    return this.http.get(API_URL_SERVICE_TIME_SESSION_BY_ID + '?serviceTimeSessionId=' + sessionid)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  confirmOrderBag(orderBag: OrderBagVM): any {
    return this.http.post(API_URL_CONFIRM_ORDER_BAG, orderBag).toPromise()

  }

  saveClientReserve(orderBag: OrderBagVM): any {
    return this.http.post(API_URL_SAVE_CLIENT_RESERVE, orderBag).toPromise()
      .catch((error: any) => Observable.throw(error || 'Server error'));

  }

  saveAppviserClientReserve(orderBag: OrderBagVM, u, p): any {
    let header: any = [{key: 'u', value: u}, {key: 'p', value: p}];

    return this.http.postWithHeader(API_URL_APPVISER_SAVE_CLIENT_RESERVE, orderBag, header).toPromise()

  }

  computeOrderbagPrice(orderBag: OrderBagVM): Observable<OrderBagVM> {
    return this.http.post(API_URL_COMPUTE_ORDER_BAG_PRICE, orderBag) // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));

  }

  getOrderBagByAuthorityCode(authorityCode: string, refid: string): Observable<OrderBagVM> {
    return this.http.get(API_URL_GET_ORDER_BAG_BY_AUTHORITY + '?authorityToken=' + authorityCode + '&refid=' + refid)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));

  }

  getOrderBagById(orderbagid: number): Observable<OrderBagVM> {
    return this.http.get(API_URL_GET_ORDER_BAG_BY_ID + '?orderBagId=' + orderbagid)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));

  }

  cancelReserve(orderbagid: number): any {
    return this.http.post(API_URL_CANCEL_RESERVE, orderbagid).toPromise();

  }


  autoSelectServantByServiceItemId(serviceId: number): Observable<ServantVM> {
    return this.http.get(API_URL_AUTO_SELECT_SERVANT_BY_SERVICE_ID + '?serviceId=' + serviceId)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));

  }

  getOrderBagDetailById(orderbagid: number): Observable<OrderBagVM> {
    return this.http.get(API_URL_GET_ORDER_BAG_DETAIL_BY_ID + '/' + orderbagid)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));

  }

  getActiveOrderBagList(companyId) {
    let url = API_URL_GET_ORDER_BAG_LIST ;
    if(companyId)
      url = url + "?companyid=" + companyId ;
    return this.http.get(url)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  confirmOrderBagPayment(authorityCode, refid): any {
    return this.http.get(API_URL_CONFIRM_ORDER_BAG_PAYMENT + '?authorityToken=' + authorityCode + '&refid=' + refid).toPromise()

  }

  deleteOrderBagByAuthority(authorityCode): any {
    return this.http.get(API_URL_DELETE_ORDER_BAG_BY_AUTHURITY + '?authorityToken=' + authorityCode).toPromise()

  }

  confirmFreeOrderBagPayment(orderBagId): any {
    return this.http.get(API_URL_FINAL_CONFIRM_ORDER_BAG + '?orderBagId=' + orderBagId).toPromise()

  }

  payOrderBag(orderBag: OrderBagVM): any {
    return this.http.post(API_URL_PAY_ORDER_BAG, orderBag).toPromise()

  }

  userCanPayInplace(companyId: number) {
    return this.http.get(API_URL_GET_USER_CAN_PAY_INPLACE + '/' + companyId);
  }


  getAvailableCapacity(timeSpan: SessionTimeVM): Observable<SessionTimeVM> {
    return this.http.post(API_URL_GET_AVAILABLE_CAPACITY_FOR_TIMESPAN, timeSpan) // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  getVideoMeetingLinkByOrderBagItemId(orderbagitemid: number): Observable<String> {
    return this.http.get(API_URL_GET_VIDEO_MEETING_LINK_BY_ORDER_BAG_ITEM_ID + '?id=' + orderbagitemid)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));

  }

  evaluateCoupon(orderBag: OrderBagVM): Observable<CouponResultVM> {
    return this.http.post(API_URL_EVALUATE_COUPON, orderBag) // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  logIntoServer(logStr: string): any {
    return this.http.post(API_URL_LOG_INTO_SERVER, logStr).toPromise();
  }

  removeOrderBagItem(orderbagItemid: number): any {
    return this.http.post(API_URL_SAVE_REMOVE_ORDER_BAG_SERVICE_ITEM_BY_ID, orderbagItemid).toPromise();
  }


}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/services/orderbag/orderbag.service.ts